import React, { useState } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { FaEye } from "react-icons/fa";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import SendButton from "../../../components/admin/usable/SendButton";
import StayoverButton from "../../../components/admin/usable/StayoverButton";
import RequestStayover from "./RequestStayover";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import { makePaid } from "../../../api/client/bookingapi";
import { useClientAuth } from "../../../utils/useAuth";
import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

const HotelBookingDetail = ({ item }) => {
  const [open, setOpen] = useState(false);
  const { company } = useClientAuth();
  const [IsLoading, setIsLoading] = useState(false);
  const calculateGrandTotal = (item) => {
    const base =
      Number(item.discountedAmount || 0) +
      Number(item.taxAmount || 0) -
      Number(item.paidAmount || 0);

    const stayoverTotal = (item.stayovers || []).reduce((sum, s) => {
      return (
        sum +
        (Number(s.discountedPrice || 0) + Number(s.serviceChargeAmount || 0))
      );
    }, 0);

    return base + stayoverTotal;
  };
  const grandTotal = calculateGrandTotal(item);
  const handleMakePaid = () => {
    if (company?.id) {
      const FormData = {
        orderId: item.id,
        totalAmount: grandTotal,
      };
      makePaid(FormData, company?.id, setIsLoading);
    } else {
      toast.error("Please refresh the page and try again");
    }
  };
  const handleDownloadInvoice = () => {
    const invoiceId = item.invoiceId;

    axiosInstance
      .get(`/booking/download/${invoiceId}`, {
        responseType: "blob", // IMPORTANT for PDF download
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", `invoice-${invoiceId}.pdf`);

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error("Can't download");
      });
  };
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-6 h-6 flex justify-center items-center bg-green-100 text-green-500 rounded-full scale-100 hover:scale-110 duration-300"
      >
        <FaEye />
      </button>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        <Sheet
          variant="outlined"
          sx={{ borderRadius: "md", p: 3, boxShadow: "lg" }}
          className="min-w-full lg:min-w-[900px] max-h-[600px] overflow-y-auto lg:h-3/4 scrollbar-hide"
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            {item.invoiceId}
          </Typography>
          <div className="w-full space-y-5">
            <div className="w-full flex lg:flex-row flex-col justify-between items-start">
              <div>
                <p>
                  <strong>Transaction Id:</strong> {item.transactionId}
                </p>
                <p>
                  <strong>Invoice Id:</strong> {item.invoiceId}
                </p>
                <p>
                  <strong>Check In:</strong> {item.checkIn}
                </p>
                <p>
                  <strong>Check Out:</strong> {item.checkOut}
                </p>
              </div>
              <div className="mt-4 lg:mt-0">
                <p>
                  <strong>Booked By:</strong> {item.fullName}
                </p>
                <p>
                  <strong>Primary Phone Number:</strong>{" "}
                  {item.primaryPhoneNumber}
                </p>
                <p>
                  <strong>Phone Number:</strong> {item.phoneNumber}
                </p>
                <p>
                  <strong>Email:</strong> {item.email}
                </p>
              </div>
            </div>
            <div className="text-center">
              <p className="text-xl font-bold">{item.hotelName}</p>
              <p className="text-xs">
                {item.hotelCity}, {item.hotelCountry}
              </p>
            </div>
            <div>
              <div className="p-4 w-full overflow-x-auto">
                <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Room Name
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Actual Price
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Discounted Price
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Service Charge
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Total Amount
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {item.rooms.map((item, index) => {
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.roomName}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.actualPrice || 0}
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.discountedPrice || 0} ({item.discount || 0}%)
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {((item.discountedPrice * item.tax) / 100).toFixed(
                              0,
                            ) || 0}{" "}
                            ({item.tax || 0}%)
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {(
                              item.discountedPrice +
                              (item.discountedPrice * item.tax) / 100
                            ).toFixed(0) || 0}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td
                        colSpan={5}
                        className="px-4 py-3 text-sm text-gray-700 text-end"
                      >
                        <p className="font-bold">Total Amount</p>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 font-bold">
                        <p>{item.discountedAmount + item.taxAmount || 0}</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        className="px-4 py-3 text-sm text-gray-700 text-end"
                      >
                        <p className="font-bold">Paid Amount</p>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 font-bold">
                        <p>{item.paidAmount || 0}</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        className="px-4 py-3 text-sm text-gray-700 text-end"
                      >
                        <p className="font-bold">Payment Status</p>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <span
                          className={`px-2 py-1 ${
                            item.paymentStatus === "Paid"
                              ? "bg-green-100 text-green-700"
                              : "bg-orange-100 text-orange-700"
                          } rounded text-xs`}
                        >
                          {item.paymentStatus === "Paid" ? "Paid" : "Unpaid"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        className="px-4 py-3 text-sm text-gray-700 text-end"
                      >
                        <p className="font-bold">Payment Option</p>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <span
                          className={`px-2 py-1 ${
                            item.paymentNature === "Partial"
                              ? " bg-orange-100 text-orange-700"
                              : "bg-green-100 text-green-700"
                          } rounded text-xs`}
                        >
                          {item.paymentNature === "Partial"
                            ? "Partial"
                            : "Full"}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {item.stayovers.length > 0 && (
                <div>
                  <div>
                    <p className="font-bold pt-1 text-start">
                      Stayover Details
                    </p>
                  </div>
                  <div className=" w-full overflow-x-auto">
                    <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            ID
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Room Name
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Actual Price
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Discounted Price
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Service Charge
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Check In
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Check Out
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Payment Status
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Status
                          </th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-gray-200">
                        {item?.stayovers.map((item, index) => {
                          return (
                            <tr className="hover:bg-gray-50">
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {index + 1}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.roomName}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.actualPrice}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.discountedPrice}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.serviceChargeAmount}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item?.checkIn
                                  ? item.checkIn.slice(0, 10)
                                  : "N/A"}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item?.checkOut
                                  ? item.checkOut.slice(0, 10)
                                  : "N/A"}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                <span
                                  className={`px-2 py-1 ${item.paymentStatus === "Paid" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"} rounded text-xs`}
                                >
                                  {item.paymentStatus}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-sm">
                                <span
                                  className={`px-2 py-1 ${item.isCancel === 0 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"} rounded text-xs`}
                                >
                                  {item.isCancel === 0 ? "Active" : "Cancelled"}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-700">
                                {item.isCancel === 0 && <DeleteButton />}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div>
              {item.guests && (
                <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Guest Name
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {item.guests.map((item, index) => {
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item || "Not Mentioned"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
            <div>
              <div className="flex justify-center items-start gap-3 flex-wrap">
                {item.isAirporPickupNeed === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Airport Pickup Required
                  </p>
                )}
                {item.isExtraBedRequired === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Extra Bed Required
                  </p>
                )}
                {item.isRoomOnHigherFloor === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Room On Higher Floor
                  </p>
                )}
                {item.isRoomDecorationRequired === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Room Decoration Required
                  </p>
                )}
                {item.IsLargeBedRequired === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Large Bed Required
                  </p>
                )}
                {item.isTwinBedRequired === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Twin Bed Required
                  </p>
                )}
                {item.isSmoking === 1 && (
                  <p className="font-bold bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Smooking Room Required
                  </p>
                )}
              </div>
              <div className="mt-4">
                <p>
                  <strong>Request:</strong> {item.request || "Not Mentioned"}
                </p>
              </div>
            </div>
            <div className="flex justify-end items-center gap-2 flex-wrap">
              <RequestStayover data={item} setOpen={setOpen} />
              <AddButton
                onClick={handleDownloadInvoice}
                text={"Download Invoice"}
              />

              <SendButton onClick={handleMakePaid} text={"Make as paid"} />

              {/* <CancelButton
                text={"Delete Invoice"}
                onClick={() => setOpen(false)}
              /> */}
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default HotelBookingDetail;
